import { createContext } from 'react';
import { UserContextType } from '../components/tev3';

const UserContext = createContext<UserContextType>({
  is_staff: false,
  is_authenticated: false,
  is_anonymous: true,
});

export default UserContext;
